// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3clK5","header":"PatientQuestionnaire_header__n1X3N","info":"PatientQuestionnaire_info__33Mn2"};